{"NODE_ENV":"production","AUTH_API_AUDIENCE":"https://aspirex.api.com"}